<template>
  <v-container fluid id="join-now-page">
    <img id="orb-1" :src="require(`../assets/orb-1.svg`)" alt="Orb 1" />
    <img id="orb-2" :src="require(`../assets/orb-2.svg`)" alt="Orb 2" />
    <img
      id="cats-group"
      :src="require(`../assets/cats-group.png`)"
      alt="Cats group"
    />
    <v-row class="ml-16 mt-12" id="content">
      <v-col xs="6" sm="8" md="6" lg="5">
        <h1 id="title">
          Join now <br />
          The very rare <br /><span style="color: #d9ad59">Kitty Club</span>.
        </h1>
        <p id="paragraph" class="mt-12 mb-10">
          Join this ultra-exclusive NFT project. Kitty Club is your ticket into
          the largest and fastest growing NFT Project.
        </p>
        <a href="#" class="glow-button mr-3">Mint now</a>
        <a href="#" class="dark-button">Join our discord</a>
        <v-row class="mt-4">
          <v-col xs="2" sm="3" md="3" class="numbers"
            ><h2>35<span style="color: #d9ad59">K+</span></h2>
            <p>Artwork</p></v-col
          >
          <v-col xs="2" sm="3" md="3" class="numbers"
            ><h2>10<span style="color: #d9ad59">K+</span></h2>
            <p>Auction</p></v-col
          >
          <v-col xs="2" sm="3" md="3" class="numbers"
            ><h2>21<span style="color: #d9ad59">K+</span></h2>
            <p>Artist</p></v-col
          >
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",

  data: () => ({}),
};
</script>
<style scoped>
.numbers h2 {
  font-size: 2.7vw !important;
}
.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 10px 30px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  cursor: pointer;
  z-index: 2;
}
.dark-button {
  text-decoration: none;
  color: white !important;
  background: #2c2f33;
  padding: 10px 30px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 2px 15px rgb(44, 47, 51, 0.4) !important;
  z-index: 2;
}
#title {
  color: white !important;
  font-weight: 500 !important;
  font-size: 5.5vw !important;
  line-height: 5vw !important;
  z-index: 2;
}
#paragraph {
  color: white !important;
  font-weight: 300 !important;
  font-size: 1.2vw !important;
  line-height: 1.2vw !important;
  z-index: 2;
}
#join-now-page {
  color: white;
  height: calc(100vh - 80px);
  background: #000000;
  position: relative;
  overflow: hidden;
  margin-top: 80px;
}
#orb-1 {
  position: absolute;
  top: -10vw;
  left: -20%;
  z-index: 0;
  width: 45vw;
  opacity: 0.8;
}
#orb-2 {
  position: absolute;
  right: -10%;
  bottom: -20vw;
  z-index: 0;
  width: 70vw;
  opacity: 0.8;
}
#cats-group {
  position: absolute;
  right: -15%;
  bottom: -4vw;
  width: 70vw;
  z-index: 1;
}
@media screen and (max-width: 961px) {
  #paragraph {
    margin-top: 15px !important;
    font-size: 2vw !important;
    line-height: 2vw !important;
  }
  #join-now-page {
    margin-top: 0px;
    height: calc(100vh - 56px);
  }
}

@media screen and (max-width: 821px) {
  #content {
    margin-left: 0 !important;
  }
  #title {
    font-size: 9vw !important;
    line-height: 8vw !important;
  }

  #paragraph {
    font-size: 3vw !important;
    line-height: 3vw !important;
  }

  .glow-button,
  .dark-button {
    font-size: 3vw !important;
  }
  .numbers {
    font-size: 3vw;
    z-index: 4;
  }
  .numbers h2 {
    font-size: 5vw !important;
  }
  #cats-group {
    right: -15%;
    width: 90vw;
  }
}
@media screen and (max-width: 426px) {
  #paragraph {
    font-size: 4vw !important;
    line-height: 4vw !important;
  }
  #title {
    font-size: 11vw !important;
    line-height: 11vw !important;
  }
  .numbers {
    font-size: 5vw;
  }
  .numbers h2 {
    font-size: 7vw !important;
  }
  #cats-group {
    right: -15%;
    width: 130vw;
  }
  #orb-2 {
    right: -10%;
    width: 120vw;
  }
}
@media screen and (max-width: 376px) {
  #paragraph {
    font-size: 3vw !important;
    line-height: 3vw !important;
  }
  #title {
    font-size: 8vw !important;
    line-height: 8vw !important;
  }
  .numbers {
    font-size: 4vw;
  }
  .numbers h2 {
    font-size: 6vw !important;
  }
  #cats-group {
    right: 3%;
    width: 100vw;
  }
  #orb-2 {
    right: 3%;
    width: 100vw;
  }
}
@media screen and (max-width: 361px) {
  #paragraph {
    font-size: 5vw !important;
    line-height: 5vw !important;
  }
  #title {
    font-size: 10vw !important;
    line-height: 10vw !important;
  }
  .numbers {
    font-size: 5vw;
  }
  .numbers h2 {
    font-size: 7vw !important;
  }
  #cats-group {
    right: 3%;
    width: 100vw;
  }
  #orb-2 {
    right: 3%;
    width: 100vw;
  }
}
</style>
